import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ACHData from '../../../models/helperTypes/ACHData';

export const initialState: ACHData = {
  accountBankId: '',
  accountBankEntityName: '',
  accountNumber: '',
  accountOwnerName: '',
  accountType: '',
  isValidAccountNumber: false,
};

const achDataSlice = createSlice({
  name: 'achData',
  initialState,
  reducers: {
    updateACHPaymentData: (state, action: PayloadAction<ACHData>): void => {
      const {
        accountOwnerName,
        accountBankEntityName,
        accountNumber,
        accountType,
        accountBankId,
      } = action.payload;
      state.accountOwnerName = accountOwnerName;
      state.accountNumber = accountNumber;
      state.accountType = accountType;
      state.accountBankId = accountBankId;
      state.accountBankEntityName = accountBankEntityName;
    },
    updateIsValidAccountNumber: (
      state,
      action: PayloadAction<boolean>,
    ): void => {
      state.isValidAccountNumber = action.payload;
    },
  },
});

export const { updateACHPaymentData, updateIsValidAccountNumber } =
  achDataSlice.actions;

export default achDataSlice.reducer;
